// extracted by mini-css-extract-plugin
export var cardBody = "style-mod--card-body--acf75";
export var cardContent = "style-mod--card-content--9d131";
export var cardTitle = "style-mod--card-title--48b00";
export var companion = "style-mod--companion--1afd8";
export var companionCard = "style-mod--companion-card--f5f65";
export var companions = "style-mod--companions--ea7bd";
export var companionsBtn = "style-mod--companions-btn--f774a";